<template>
  <v-container fluid full-height grid-list-md>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <vue-title :title="pageTitle + ' | JUDO POS'"></vue-title>
    <v-layout row>
      <v-flex xs12 v-if="isBreadcrumbs">
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs12>
        <div class="text-xs-right">
          <v-btn outline color="primary" @click="goBack">
            Go Back
            <v-icon right>arrow_back</v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap transition="slide-x-transition">
        <v-flex xs6 mt-1>
          <v-card>
            <v-layout row wrap>
               <v-flex xs5 ml-4>
                <v-autocomplete
                  v-model="currencyId"
                  :items="currencyList"
                  color="blue-grey lighten-2"
                  label="Choose Currency..."
                  item-text="code"
                  menu-props="auto"
                  prepend-icon="monetization_on"
                  @change="changeCurrencyCode(),onSearch(), init()"
                  item-value="id"
                  :readonly='!!wholeSaleHeader.id'
                  :rules="rules.currencyRules" 
                ></v-autocomplete>
              </v-flex>
              <v-flex xs5 ml-4>
                <v-text-field
                  label="Customer Name"
                  v-model="wholeSaleHeader.customerName"
                  @click.stop="showCustomers()"
                  :disabled="status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN'"
                  prepend-icon="account_box"
                ></v-text-field>
                <span class="pl-4 info--text" v-if="!wholeSaleHeader.customerName">Please select customer first.</span>
              </v-flex>
              <!-- Barcode input -->
              <v-flex xs5 ml-4>
                <v-text-field
                  name="scanBarcode"
                  label="Scan barcode....."
                  v-model="scanBarcode"
                  type="text"
                  v-on:keyup.enter="trigger(scanBarcode)"
                  autofocus
                  prepend-icon="filter_center_focus"
                  :readonly="status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN' || !currencyId || !wholeSaleHeader.customerName"
                ></v-text-field>
              </v-flex>
              <!-- Barcode input -->

              <v-flex xs5 mt-1 ml-5>
                <v-btn
                  color="primary"
                  outline
                  @click="isShowStock=!isShowStock; "
                  :disabled="status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN' || !currencyId || !wholeSaleHeader.customerName"
                >
                  <v-icon left>remove_red_eye</v-icon>
                  <span v-if="!isShowStock">Show Stock</span>
                  <span v-else>Hide Stock</span>
                </v-btn>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <!-- Barcode input -->
              <v-flex xs5 ml-4>
                <v-text-field
                  name="enteredProductCode"
                  label="Enter product code"
                  v-model="enteredProductCode"
                  type="text"
                  v-on:keyup.enter="getProductByCode(enteredProductCode)"
                  autofocus
                  prepend-icon="assignment_returned"
                  :readonly="status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN' || !currencyId || !wholeSaleHeader.customerName"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <!-- Product Group Code input -->
              <v-flex xs5 ml-4>
                <v-text-field
                  name="enteredProductGroupCode"
                  label="Enter product group code"
                  v-model="enteredProductGroupCode"
                  type="text"
                  v-on:keyup.enter="getProductGroupByCode(enteredProductGroupCode), isShowStock=true, categoryName=''"
                  prepend-icon="assignment_returned"
                  :readonly="status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN' || !currencyId || !wholeSaleHeader.customerName"
                ></v-text-field>
              </v-flex>

              <v-flex xs5 ml-5 mt-1>
                <v-switch
                  :readonly="status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN'"
                  v-model="isFOC"
                  inset
                  :label="isFOC == true ? 'FOC' : 'Sale'"
                ></v-switch>
              </v-flex>
            </v-layout>

            <v-divider></v-divider>
            <!-- Sale Items cart -->
            <v-flex xs16 ma-3 pa-2>
              <v-card>
                <v-card-title primary-title>
                  <div>
                    <div class="title">Whole Sale Items</div>
                  </div>
                </v-card-title>
                <v-card-text class="cart">
                  <v-layout row>
                    <v-flex xs12 sm2>Code</v-flex>
                    <v-flex xs12 sm5 class="text-xs-center">Stock Name</v-flex>
                    <v-flex xs12 sm2 class="text-xs-center">Qty</v-flex>
                    <v-flex xs12 sm3 class="text-xs-center">Price</v-flex>
                    <v-flex xs12 sm3 class="text-xs-center">Amount</v-flex>
                    <v-flex xs12 sm3 class="text-xs-center">Remark</v-flex>
                    <v-flex xs12 sm1></v-flex>
                  </v-layout>
                  <v-divider></v-divider>

                  <v-flex v-if="getSaleItems.length == 0" text-xs-center ma-3>No items.</v-flex>
                  <v-flex
                    style="max-height:70vh;overflow-y:auto;overflow-x:hidden;"
                    v-for="(item, index) in wholeSaleHeader.wholeSaleDetails"
                    :key="index"
                  >
                    <v-layout row class="white" v-if="item.isFOC !== true">
                      <v-flex xs12 sm2 pt-4>{{item.barcode}}</v-flex>
                      <v-flex xs12 sm5 pt-4>{{item.productName}}</v-flex>
                      <v-flex xs12 sm2>
                        <v-text-field
                          class="small-font"
                          v-model="item.qty"
                          min="0"
                          type="number"
                          :rules="rules.qtyRules"
                          oninput="this.value = Math.abs(this.value)"
                          :readonly="status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3>
                        <v-text-field
                          class="small-font"
                          v-model="item.unitPrice"
                          type="number"
                          min="0"
                          oninput="this.value = Math.abs(this.value)"
                          readonly
                          :rules="rules.wholesalePriceRules"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 pt-4>
                        {{item.qty * item.unitPrice | decFormat}}
                        <span
                          v-if="isShowCurrency"
                        >{{ currency }}</span>
                      </v-flex>
                      <v-flex xs12 sm3>
                        <v-text-field
                          class="small-font"
                          v-model="item.remark"
                          :rules="rules.remarkRules"
                          :readonly="status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm1 pt-2>
                        <v-btn
                          icon
                          @click="removeItem(index, item.id)"
                          :disabled="status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN'"
                        >
                          <v-icon>cancel</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>
            <!-- FOC Items cart -->
            <v-flex xs16 ma-3 pa-2>
              <v-card>
                <v-card-title primary-title>
                  <div>
                    <div class="title">FOC Items</div>
                  </div>
                </v-card-title>
                <v-card-text class="cart">
                  <v-layout row>
                    <v-flex xs12 sm2>Code</v-flex>
                    <v-flex xs12 sm5 class="text-xs-center">Stock Name</v-flex>
                    <v-flex xs12 sm2 class="text-xs-center">Qty</v-flex>
                    <v-flex xs12 sm3 class="text-xs-center">Remark</v-flex>
                    <v-flex xs12 sm1></v-flex>
                  </v-layout>
                  <v-divider></v-divider>

                  <v-flex v-if="getFOCItems.length == 0" text-xs-center ma-3>No items.</v-flex>
                  <v-flex
                    style="max-height:70vh;overflow-y:auto;overflow-x:hidden;"
                    v-for="(item, index) in wholeSaleHeader.wholeSaleDetails"
                    :key="index"
                  >
                    <v-layout row class="white" v-if="item.isFOC === true">
                      <v-flex xs12 sm2 pt-4>{{item.barcode}}</v-flex>
                      <v-flex xs12 sm5 pt-4>{{item.productName}}</v-flex>
                      <v-flex xs12 sm2>
                        <v-text-field
                          :readonly="status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN'"
                          class="small-font"
                          v-model="item.qty"
                          min="0"
                          type="number"
                          :rules="rules.qtyRules"
                          oninput="this.value = Math.abs(this.value)"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3>
                        <v-text-field
                          :readonly="status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN'"
                          class="small-font"
                          v-model="item.remark"
                          :rules="rules.remarkRules"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm1 pt-2>
                        <v-btn
                          icon
                          @click="removeItem(index, item.id)"
                          :disabled="status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN'"
                        >
                          <v-icon>cancel</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>
            <!-- cart -->
          </v-card>
        </v-flex>
        <v-flex xs6>
          <!-- Stock -->
          <v-slide-y-transition>
            <v-card>
              <v-layout>
                <v-flex>
                  <v-flex>
                    <v-menu
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :disabled="status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN'"
                    >
                      <v-text-field
                        label="IssueDate"
                        slot="activator"
                        type="text"
                        prepend-icon="event"
                        v-model="issueDate"
                        readonly
                        :rules="rules.issueDateRules"
                      ></v-text-field>
                      <v-date-picker v-model="issueDate" :rules="rules.issueDateRules"></v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-flex>
                <v-flex v-if="wholeSaleHeader.id">
                  <v-flex ml-3 mr-3 mt-2>
                    <v-select
                      :items="statusList"
                      label="Status"
                      item-text="label"
                      item-value="value"
                      v-model="wholeSaleHeader.status"
                      :readonly="status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN'"
                    ></v-select>
                  </v-flex>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-flex v-show="isShowStock">
                <v-layout row>
                  <v-flex xs8 pa-3 mt-1 class="text-xs-right">
                    <h3>
                      Total Amount: {{netAmount | decFormat}}
                      <span
                        v-if="isShowCurrency"
                      >{{ currency }}</span>
                    </h3>
                  </v-flex>
                  <v-flex xs4 ml-1>
                    <v-btn
                      color="success"
                      large
                      @click="showPaymentMethods()"
                      :disabled="wholeSaleHeader.wholeSaleDetails.length === 0 || !valid"
                    >Make Payment</v-btn>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-expansion-panel v-model="categoryPanel" mb-3>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div>
                        <strong>Category : {{categoryName}}</strong>
                      </div>
                    </template>
                    <v-layout row wrap pa-2>
                      <v-flex xs4 v-for="(category, index) in categoryList" :key="index">
                        <v-btn
                          block
                          color="primary"
                          @click="onSearch(category);categoryPanel=false"
                        >{{category.name}}</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-flex v-if="categoryName == ''">
                  <h3>Product Group Name : {{ productGroupName }}</h3>
                </v-flex>
                <v-flex mt-3 style="max-height:100vh;overflow-y:auto;overflow-x:hidden;">
                  <v-data-iterator
                    :items="productList"
                    :total-items="totalRows"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="pagination"
                    :loading="showListLoading"
                    content-tag="v-layout"
                    row
                    wrap
                  >
                    <v-flex slot="item" slot-scope="props" xs12 sm6 md4 lg3>
                      <v-hover>
                        <v-card
                          slot-scope="{ hover }"
                          :class="`elevation-${hover ? 4 : 0}`"
                          class="mx-auto"
                          :title="props.item.name"
                          @click="showProductUnitDialog(props.item)"
                        >
                          <v-img
                            v-if="props.item.imageUrl"
                            :aspect-ratio="16/9"
                            :src="props.item.imageUrl"
                          ></v-img>
                          <v-card-title>
                            <div class="grey--text">{{props.item.code}}</div>
                            <div class="stock-name">{{props.item.name}}</div>
                          </v-card-title>
                        </v-card>
                      </v-hover>
                    </v-flex>
                  </v-data-iterator>
                </v-flex>
              </v-flex>
            </v-card>
          </v-slide-y-transition>

          <!-- Stock -->
          <v-slide-y-reverse-transition>
            <v-flex v-show="!isShowStock">
              <v-layout row>
                <!-- Counter Detail -->
                <v-flex xs6 pb-2>
                  <v-flex xs12>
                    <strong>Shop Name:</strong>
                    {{wholeSaleHeader.shopName}}
                  </v-flex>
                </v-flex>
                <!-- Counter Detail -->

                <!-- Retrieve / Park Sale -->
                <v-flex xs6 mt-2>
                  <v-btn
                    @click="showParkSales = !showParkSales"
                    :disabled="status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN'"
                  >
                    <i class="material-icons">reply</i>Retrieve Sale
                  </v-btn>
                  <v-btn
                    @click="showNote = !showNote"
                    :disabled="wholeSaleHeader.wholeSaleDetails.length === 0 || status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN'"
                  >
                    <i class="material-icons">settings_backup_restore</i>Park Sale
                  </v-btn>
                </v-flex>
                <!-- Retrieve / Park Sale -->
              </v-layout>
              <!--  -->
              <!-- receipt Section -->
              <v-divider></v-divider>
              <v-layout row>
                <v-flex xs8>Total Amount:</v-flex>
                <v-flex xs4 class="text-xs-right">
                  {{wholeSaleHeader.totalAmount | decFormat}}
                  <span
                    v-if="isShowCurrency"
                  >{{ currency }}</span>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs8>Tax({{wholeSaleHeader.taxType}})({{wholeSaleHeader.taxPercentage}}%):</v-flex>
                <v-flex xs4 class="text-xs-right">
                  {{wholeSaleHeader.taxAmount | decFormat}}
                  <span
                    v-if="isShowCurrency"
                  >{{ currency }}</span>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-layout row>
                <v-flex xs8>
                  <h3>Net Amount:</h3>
                </v-flex>
                <v-flex xs4 class="text-xs-right">
                  <h3>
                    {{netAmount | decFormat}}
                    <span v-if="isShowCurrency">{{ currency }}</span>
                  </h3>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-layout row>
                <v-flex xs12 text-xs-right>
                  <v-btn
                    color="success"
                    large
                    @click="showPaymentMethods()"
                    :disabled="wholeSaleHeader.wholeSaleDetails.length === 0"
                  >Make Payment</v-btn>
                </v-flex>
              </v-layout>
              <!-- receipt section -->
            </v-flex>
          </v-slide-y-reverse-transition>
        </v-flex>
      </v-layout>
    </v-form>
    <!-- Invoice print hidden area -->
    <!-- <invoice id="invoicePrint" :wholeSaleHeader-data="wholeSaleHeader"></invoice> -->
    <div id="invoicePrint" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:11px;margin:0px">{{wholeSaleHeader.shopName}}</p>
      </div>
      <div style="text-align:center">
        <p style="font-size:11px;margin:0px">{{wholeSaleHeader.address}}</p>
      </div>
      <div style="text-align:center">
        <p style="font-size:11px;margin:0px">Tel: {{wholeSaleHeader.phoneNo}}</p>
      </div>
      <div style="text-align:center">
        <p style="font-size:11px;margin:0px">Invoice #: {{wholeSaleHeader.issueNo}}</p>
      </div>
      <div style="text-align:center">
        <p style="font-size:11px;margin:0px" id="date"></p>
      </div>
      <div style="float:right;padding-right:11px">
        <p style="font-size:11px;margin:0px" id="casher">Casher: {{wholeSaleHeader.username}}</p>
      </div>
      <div style="clear:both"></div>
      <div style="height:10px"></div>
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="text-align:left"></th>
              <th style="text-align:center">Unit</th>
              <th style="text-align:center">Qty</th>
              <th style="text-align:right">Price</th>
              <th style="text-align:right">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in getSaleItems" :key="index">
              <td style="text-align:left">{{item.productName}}</td>
              <td style="text-align:center">{{item.factorUnitName}}</td>
              <td style="text-align:center">{{item.qty}}</td>
              <td style="text-align:right">{{item.unitPrice | decFormat}}</td>
              <td style="text-align:right">{{item.qty * item.unitPrice | decFormat}}</td>
            </tr>
          </tbody>
        </table>
        <div style="height:10px"></div>
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;border-top:1px solid black"
        >
          <tr>
            <td></td>
            <td></td>
            <td style="text-align:right;font-weight:bold;font-size:11px">Total Amount</td>
            <td
              style="text-align:right;font-weight:bold;font-size:11px"
            >{{wholeSaleHeader.totalAmount | decFormat}}</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td
              style="text-align:right;font-weight:bold;font-size:11px"
            >Tax ({{wholeSaleHeader.taxType}})</td>
            <td
              style="text-align:right;font-weight:bold;font-size:11px"
            >{{wholeSaleHeader.taxAmount | decFormat}}</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td style="text-align:right;font-weight:bold;font-size:11px">Discount Amount</td>
            <td
              style="text-align:right;font-weight:bold;font-size:11px"
              v-if="this.wholeSaleHeader.discountAmount > 0"
            >{{this.wholeSaleHeader.discountAmount | decFormat}}</td>
            <td style="text-align:right;font-weight:bold;font-size:11px" v-else>0</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td style="text-align:right;font-weight:bold;font-size:11px">Net Amount</td>
            <td style="text-align:right;font-weight:bold;font-size:11px">{{netAmount | decFormat}}</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td style="text-align:right;font-weight:bold;font-size:11px">Deposit Amount</td>
            <td
              style="text-align:right;font-weight:bold;font-size:11px"
              v-if="this.wholeSaleHeader.depositAmount > 0"
            >{{this.wholeSaleHeader.depositAmount | decFormat}}</td>
            <td style="text-align:right;font-weight:bold;font-size:11px" v-else>0</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td style="text-align:right;font-weight:bold;font-size:11px">Remaining Amount</td>
            <td
              style="text-align:right;font-weight:bold;font-size:11px"
            >{{remainingAmount | decFormat}}</td>
          </tr>
        </table>
      </div>
      <!-- FOC Items -->
      <div style="clear:both"></div>
      <div style="height:10px"></div>
      <div style="padding-left:5px;padding-right:5px" v-if="getFOCItems.length > 0">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="text-align:left">FOC Items</th>
              <th style="text-align:center">Unit</th>
              <th style="text-align:center">Qty</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in getFOCItems" :key="index">
              <td style="text-align:left">{{item.productName}}</td>
              <td style="text-align:center">{{item.factorUnitName}}</td>
              <td style="text-align:center">{{item.qty}}</td>
            </tr>
          </tbody>
        </table>
        <div style="height:10px"></div>
      </div>
      <div style="height:5px;"></div>
      <div style="text-align:center">
        <p style="font-size:11px;margin:0px">Thank You! Please Come Again.</p>
      </div>
    </div>
    <!-- final message dialog -->
    <v-dialog v-model="messageDialogBox" max-width="500px" @keydown.enter="messageDialogBox=false">
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Park sales dialog-->
    <v-dialog v-model="showParkSales" persistent max-width="500">
      <v-card>
        <v-card-title>
          <h3>Park Sales</h3>
        </v-card-title>
        <v-card-text>
          <v-layout row v-for="(item, index) in parkItems" :key="index">
            <v-flex xs12 sm3 class="grey--text">Note: {{item.note}}</v-flex>
            <v-flex xs12 sm3>{{item.saleItems[0].barcode}}</v-flex>
            <v-flex xs12 sm3>{{item.saleItems[0].productName}}</v-flex>
            <v-flex xs12 sm3>{{item.saleItems[0].factorUnitName}}</v-flex>
            <v-flex xs12 sm3>
              <v-btn color="primary" @click="retrieveSale(index)">
                <v-icon>reply</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row v-show="parkItems.length === 0">
            <v-flex>There is no park wholeSaleHeader.</v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="showParkSales = !showParkSales">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Show note dialog-->
    <v-dialog v-model="showNote" persistent max-width="290">
      <v-form ref="noteDialog" @submit.prevent="parkSale">
        <v-card>
          <v-card-text>
            <v-text-field
              label="Note"
              required
              v-model="wholeSaleHeader.note"
              :rules="[v => !!v || 'Note is required']"
            ></v-text-field>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" flat @click.native="closeModal">
                Cancel
                <v-icon right>clear</v-icon>
              </v-btn>
              <v-btn color="blue darken-1" flat type="submit">
                Save
                <v-icon right>save</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>

    <!--Payment dialog-->
    <v-dialog v-model="showPaymentMethodDialog" max-width="800" @keydown.enter="confirmPayment()">
      <v-form ref="paymentModalForm" lazy-validation @submit.prevent="confirmPayment">
        <v-card>
          <v-card-text max-height="auto">
            <v-layout row>
              <v-flex xs4>
                <v-flex ml-3 mr-3 mt-2>
                  <h2>Tax On</h2>
                  <v-checkbox
                    v-model="isTaxOn"
                    @change="calculateAmount"
                    :disabled="status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN'"
                  ></v-checkbox>
                </v-flex>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex xs12>
                <v-flex ma-3>
                  <h2>
                    Total Amount :
                    <span style="color:green">
                      {{wholeSaleHeader.totalAmount | decFormat}}
                      <span
                        v-if="isShowCurrency"
                      >{{ currency }}</span>
                    </span>
                  </h2>
                </v-flex>
              </v-flex>
              <v-flex xs12 v-if="isTaxOn">
                <v-flex ma-3>
                  <h2>
                    Tax({{wholeSaleHeader.taxType}}):
                    <span style="color:red">
                      {{ wholeSaleHeader.taxAmount | decFormat}}
                      <span
                        v-if="isShowCurrency"
                      >{{ currency }}</span>
                    </span>
                  </h2>
                </v-flex>
              </v-flex>
              <v-flex xs12>
                <v-flex ml-3 mr-3 mt-2>
                  <h2>
                    Discount Amount:
                    <v-text-field
                      v-model="wholeSaleHeader.discountAmount"
                      label="Amount"
                      min="0"
                      type="number"
                      outline
                      :prefix="currency"
                      :rules="rules.discountAmountRules"
                      :readonly="status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN'"
                    >
                      <span v-if="isShowCurrency">{{ currency }}</span>
                    </v-text-field>
                  </h2>
                </v-flex>
              </v-flex>
              <v-flex xs12 v-if="discountError">
                &nbsp;&nbsp;
                <span class="red--text">&nbsp;&nbsp;{{discountError}}</span>
              </v-flex>
              <v-flex xs12 ma-3>
                <h1>
                  Net Amount:
                  <span style="color:green">
                    {{ netAmount | decFormat}}
                    <span v-if="isShowCurrency">{{ currency }}</span>
                  </span>
                </h1>
              </v-flex>
              <v-flex xs12>
                <v-flex ml-3 mr-3 mt-2>
                  <h2>
                    Deposit Amount:
                    <v-text-field
                      v-model="wholeSaleHeader.depositAmount"
                      label="Amount"
                      min="0"
                      type="number"
                      outline
                      :prefix="currency"
                      :readonly="status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN'"
                      :rules="rules.depositeAmountRules(netAmount)"
                    >
                      <span v-if="isShowCurrency">{{ currency }}</span>
                    </v-text-field>
                  </h2>
                </v-flex>
              </v-flex>
              <v-flex xs12 ma-3>
                <v-textarea
                  :readonly="status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN'"
                  solo
                  name="description"
                  label="Description"
                  v-model="wholeSaleHeader.description"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 ma-3>
                <v-textarea
                  :readonly="status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN'"
                  solo
                  name="delivery info"
                  label="Delivery Info"
                  v-model="wholeSaleHeader.deliveryInfo"
                  :rules="rules.deliveryInfoRules"
                ></v-textarea>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex text-xs-center mt-3>
                <v-btn
                  :disabled="status == 'FINISHED' || status == 'CANCEL' || roleName == 'ADMIN' || roleName =='BRANCH_ADMIN'"
                  color="success"
                  large
                  outline
                  @click="confirmPayment"
                >Confrim Payment</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" flat @click="showPaymentMethodDialog = !showPaymentMethodDialog">
              Close
              <v-icon right>clear</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- ProductUnit dialog -->
    <v-dialog v-model="openProductUnitDialog" persistent max-width="700">
      <v-card>
        <v-card-title>
          <h2>Choose Stock</h2>
        </v-card-title>
        <v-card-title>
          <h3>Product Code: {{ productCode }}</h3>
        </v-card-title>
        <v-card-title>
          <h3>Product Name: {{ productName }}</h3>
        </v-card-title>
        <v-card-title>
          <h3>Product Color: {{ productColor }}</h3>
        </v-card-title>
        <v-layout row wrap pa-2>
          <v-flex v-for="(productUnit, index) in productUnitList" :key="index" xs12 sm6 md4 lg3>
            <v-hover>
              <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 4 : 0}`" class="mx-auto">
                <v-card-title>
                  <p class="grey--text">{{productUnit.barcode}}</p>
                  <p class="grey--text">{{productUnit.product.name}}</p>
                  <p v-if="wholeSaleHeader.isB2B && wholeSaleHeader.customerType == 'B2B'">{{productUnit.unitCost | decFormat}} {{currency}}</p>
                  <p v-else>{{productUnit.wholesalePrice | decFormat}} {{currency}}</p>
                  <p>Unit: {{productUnit.factorUnitName}}</p>
                  <p>Available Qty: {{productUnit.qty}}</p>
                </v-card-title>
                <v-card-actions>
                  <v-btn
                    :disabled="productUnit.qty == 0 || (productUnit.reorderQty > 0 && (productUnit.qty * productUnit.factor) <= productUnit.reorderQty)"
                    :ref="`bc-${productUnit.barcode}`"
                    outline
                    color="orange"
                    @click="addToCart(productUnit)"
                  >Add To Card</v-btn>
                </v-card-actions>
              </v-card>
            </v-hover>
          </v-flex>
          <v-flex v-if="!productUnitList.length">
            <h5 style="color:red">*There is no productUnit.</h5>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            color="primary"
            @click.native="openProductUnitDialog = !openProductUnitDialog"
          >Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Customer list dialog -->
    <v-dialog v-model="showCustomerListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex sm3>
              <v-text-field name="code" label="Code" type="text" v-model="customerQueryParams.code"></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Customer Name"
                type="text"
                v-model="customerQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="email"
                label="Customer Email"
                type="text"
                v-model="customerQueryParams.email"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="creditLevelList"
                v-model="customerQueryParams.creditLevelId"
                label="Choose Credit Level"
                item-text="name"
                item-value="id"
                menu-props="auto"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="customerOnSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Customer List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="customerList"
                class="elevation-1"
                :loading="showCustomerListLoading"
                :total-items="customerTotalRows"
                :rows-per-page-items="customerRowsPerPageItems"
                :pagination.sync="customerPagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td @click="setCustomer(props.item)">
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.email }}</td>
                  <td>{{ props.item.phoneNo }}</td>
                  <td>{{ props.item.creditLevel.name}}</td>
                  <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
                  <td>{{ props.item.updatedBy }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- confrim dialog -->
    <v-dialog
      v-model="confirmBox"
      max-width="500px"
      @keydown.enter="proceedPayment()"
      @keydown.esc="open = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>Are you sure to make this payment transaction?</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="confirmBox=false">Cancel</v-btn>
          <v-btn color="success" large outline @click="proceedPayment()">Proceed</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
// import invoice from "./invoice";
import { productService } from "../../services/product-service";
import { taxService } from "../../services/tax-service";
import { categoryService } from "../../services/category-service";
import { customerService } from "../../services/customer-service";
import { Tax } from "../../models/model";
import { WholeSaleHeader } from "../../models/model";
import { wholeSaleService } from "../../services/whole-sale-service";
import { WholeSaleFormRules } from "../../helpers/validation-rules";
import { creditLevelService } from "../../services/credit-level-service";
import { commonService } from "../../services/common-service";
import { currencyService } from "../../services/currency-service";
import { discountService } from "../../services/discount-service";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "StockList",
  components: {
    Loading
  },
  data: () => ({
    rules: new WholeSaleFormRules(),
    valid: true,
    responseError: "",
    isShowStock: false,
    pageTitle: "Whole Sale",
    showListLoading: false,
    showCustomerListLoading: false,
    ignorePagingWatch: true,
    isBreadcrumbs: false,
    breadcrumbs: [
      {
        text: "Whole Sale",
        disabled: true
      }
    ],
    rowsPerPageItems: [8, 16, 24, 48],
    pagination: {
      page: 1,
      rowsPerPage: 8,
      sortBy: "createdDate",
      totalItems: 0
    },
    stockList: [],
    categoryName: "",
    productGroupName: "",
    productList: [],
    categoryList: [],
    counterList: [],
    totalRows: 0,
    customerTotalRows: 0,
    parkItems: [],
    showParkSales: false,
    showNote: false,
    showPaymentMethodDialog: false,
    modalValid: true,
    scanBarcode: "",
    headers: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Email", value: "email" },
      { text: "PhoneNo", value: "phoneNo" },
      { text: "Credit Level", value: "creditLevel", sortable: false },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" }
    ],
    queryParams: {
      status: "ACTIVE",
      categoryId: "",
      warehouseId: "",
      isSaleUnit: true,
      currencyId: ""
    },
    customerQueryParams: {
      code: "",
      name: "",
      email: "",
      creditLevelId: ""
    },
    customerRowsPerPageItems: [25, 50, 100],
    customerPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0
    },
    autoCompleteParams: {
      code: ""
    },
    discountPercentage: 0,
    cardNo: "",
    tax: new Tax(),
    tableInfos: [],
    wholeSaleHeader: new WholeSaleHeader(),
    netAmount: 0,
    isShowCurrency: true,
    currency: "MMK",
    categoryPanel: false,
    selectedPaymentMethod: 1,
    confirmBox: false,
    productCode: "",
    productColor: "",
    productName: "",
    productUnitList: [],
    openProductUnitDialog: false,
    isTaxOn: false,
    messageDialogBox: false,
    receivedAmount: 0,
    remainingAmount: 0,
    currencyId: "",
    currencyList: [],
    productCodeList: [],
    enteredProductCode: "",
    enteredProductGroupCode: "",
    customerList: [],
    isFOC: false,
    saleItems: [],
    focItems: [],
    isFOCItemsExist: false,
    isSaleItemsExist: false,
    isLoading: false,
    fullPage: true,
    showCustomerListDialog: false,
    creditLevelList: [],
    statusList: [
      { label: "All", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "QUOTATION", value: "QUOTATION" },
      { label: "FINISHED", value: "FINISHED" },
      { label: "CANCEL", value: "CANCEL" }
    ],
    issueDate: "",
    oldWholeSaleHeader: new WholeSaleHeader(),
    status: "DRAFT",
    roleName: "",
    discountError: "",
    discountAmount: 0,
    saveLoading: false,
  }),
  computed: {
    getFOCItems() {
      return this.wholeSaleHeader.wholeSaleDetails.filter(
        item => item.isFOC === true
      );
    },
    getSaleItems() {
      return this.wholeSaleHeader.wholeSaleDetails.filter(
        item => item.isFOC !== true
      );
    }
  },
  watch: {
    pagination: {
      handler() {
        if (!this.ignorePagingWatch) {
          this.getProductList();
        }
      },
      deep: true
    },
    customerPagination: {
      handler() {
        this.getCustomerList();
      },
      deep: true
    },
    wholeSaleHeader: {
      handler() {
        this.calculateAmount();
      },
      deep: true
    }
  },
  created() {
    this.getActiveCurrency()
    .finally(() => {
        this.init();
    });   
  },
  mounted() {
    this.$emit("drawer", false);
  },
  destroyed() {
    this.$emit("drawer", null);
  },
  methods: {
    changeCurrencyCode(){
    let cu = commonService.search("id",this.currencyId,this.currencyList);
    this.currency = cu.code;
    },
    getProductByCode(enteredProductCode) {
      productService
        .getProductByCode(enteredProductCode,this.queryParams.isSaleUnit, this.currencyId)
        .then(res => {
          if (res.data) {
            this.showProductUnitDialog(res.data);
          } else {
            this.responseError = "Invalid Product Code !";
            this.messageDialogBox = true;
          }
          this.enteredProductCode = "";
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProductGroupByCode(enteredProductGroupCode) {
      if (enteredProductGroupCode) {
        this.queryParams.productGroupCode = enteredProductGroupCode;
        this.queryParams.categoryId = "";
      }
      this.pagination.page = 1;
      this.pagination.rowsPerPage = 8;
      this.$router.replace({
        name: "whole-sale-detail",
        query: this.queryParams
      });
      this.productList = [];
      this.getProductList();
      if (this.productList.length === 0) {
        this.productGroupName = "";
        this.totalRows = 0;
      }
      this.enteredProductGroupCode = "";
    },
    confirmPayment() {
      if (!this.$refs.paymentModalForm.validate()) {
        return;
      }
      if (
        this.discountAmount > 0 &&
        this.wholeSaleHeader.discountAmount > this.discountAmount
      ) {
        this.wholeSaleHeader.discountAmount = 0;
        this.discountError =
          "*Discount amount must not be greater than " +
          Math.floor(this.discountAmount*100)/100+
          this.currency;
      } else {
        this.showPaymentMethodDialog = false;
        this.confirmBox = true;
        this.discountError = "";
      }
    },
    proceedPayment() {
      this.save();
      this.showPaymentMethodDialog = false;
      this.confirmBox = false;
    },
    cancelPayment() {
      this.showPaymentMethods();
    },
    trigger(barcode) {
      if (barcode) {
        this.getProductUnitByBarcode(barcode);
      }
    },
    onSearch(category) {
      if (category) {
        this.queryParams.categoryId = category.id;
        this.queryParams.productGroupCode = "";
        this.categoryName = category.name;
      }
      this.pagination.page = 1;
      this.pagination.rowsPerPage = 8;
      this.$router.replace({
        name: "whole-sale-detail",
        query: this.queryParams
      });
      this.queryParams.currencyId = this.currencyId;
      this.getProductList();
    },
    customerOnSearch() {
      this.customerQueryParams.page = this.customerPagination.page;
      this.customerQueryParams.size = this.customerPagination.rowsPerPage;
      this.getCustomerList();
    },
    getCustomerList() {
      this.showCustomerListLoading = true;
      let order = this.customerPagination.descending ? "desc" : "asc";
      return customerService
        .getCustomers(
          this.customerQueryParams,
          this.customerPagination.page,
          this.customerPagination.rowsPerPage,
          this.customerPagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.customerList = res.data.customerList;
            this.customerTotalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showCustomerListLoading = false;
        });
    },
    showCustomers() {
      // Clean query params
      this.customerQueryParams.name = "";
      this.customerQueryParams.email = "";
      this.customerQueryParams.creditLevelId = "";

      this.getCustomerList().then(
        (this.showCustomerListDialog = !this.showCustomerListDialog)
      );
    },
    getTax() {
      return taxService
        .getTaxByStatus("ACTIVE")
        .then(res => {
          if (res.data) {
            this.tax = res.data;
            this.wholeSaleHeader.taxId = this.tax.id;
            this.wholeSaleHeader.taxName = this.tax.name;
            this.wholeSaleHeader.taxType = this.tax.taxType;
            this.wholeSaleHeader.taxPercentage = this.tax.percentage;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProductList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      productService
        .getProductList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy ? this.pagination.sortBy + "," + order : ""
        )
        .then(res => {
          if (res.data) {
            this.productList = res.data.productList;
            this.productGroupName = this.productList[0].productGroupName;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getCategoriesByStatus() {
      return categoryService
        .getCategoriesByStatus("ACTIVE")
        .then(res => {
          this.categoryList = res.data;
          if (!this.queryParams.categoryId) {
            this.queryParams.categoryId = this.categoryList[0].id;
            this.categoryName = this.categoryList[0].name;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    addToCart(productUnit) {
      if (this.isItemExist(productUnit, this.isFOC)) {
        let isFOCFlag = this.isFOC;
        this.wholeSaleHeader.wholeSaleDetails.forEach(function(item) {
          if (
            item.productUnitId === productUnit.id &&
            item.isFOC === isFOCFlag
          ) {
            item.qty = Math.abs(item.qty) + 1;
          }
        });
      } else {
        let item = {
          productUnitId: 0,
          productId: 0,
          qty: 0,
          unitPrice: 0,
          unitCost: 0,
          wholeSalePrice: 0,
          barcode: "",
          totalPrice: 0,
          factorUnitName: "",
          productName: "",
          isFOC: false,
          remark: ""
        };

        item.productUnitId = productUnit.id;
        item.productId = productUnit.product.id;
        item.barcode = productUnit.barcode;
        item.qty = 1;
        if(this.wholeSaleHeader.isB2B && this.wholeSaleHeader.customerType == "B2B") {
          //for not b2b shop wholesale
          item.unitPrice = productUnit.unitCost;
          //for b2b shop wholesale
          item.unitCost = productUnit.unitCost;
          item.wholeSalePrice = productUnit.wholesalePrice;
        } else {
          //for not b2b shop wholesale
          item.unitPrice = productUnit.wholesalePrice;
          //for b2b shop wholesale
          item.unitCost = productUnit.unitCost;
          item.wholeSalePrice = productUnit.wholesalePrice;
        }
        item.factorUnitName = productUnit.factorUnitName;
        item.productName = productUnit.product.name;
        if (this.isFOC) {
          item.isFOC = this.isFOC;
        }
        this.wholeSaleHeader.wholeSaleDetails.push(item);
      }
    },
    calculateAmount() {
      let total = 0;
      this.wholeSaleHeader.wholeSaleDetails.forEach(item => {
        if (!item.isFOC) {
          item.totalPrice = item.qty * item.unitPrice;
          total += item.totalPrice;
        }
      });
      this.wholeSaleHeader.totalAmount = parseFloat(total).toFixed(2);
      let commercialTax = 0;
      if (this.wholeSaleHeader.taxPercentage > 0) {
        commercialTax = total * (this.wholeSaleHeader.taxPercentage / 100);
      }
      if (!this.isTaxOn) {
        commercialTax = 0;
      }
      let taxType = this.wholeSaleHeader.taxType;
      if (taxType === "ADD_ON") {
        this.netAmount = total + commercialTax;
      } else {
        this.netAmount = total - commercialTax;
      }
      this.wholeSaleHeader.discountAmount = parseFloat(this.wholeSaleHeader.discountAmount);
      this.wholeSaleHeader.depositAmount = parseFloat(this.wholeSaleHeader.depositAmount);
      this.wholeSaleHeader.taxAmount = commercialTax;
      this.netAmount = this.netAmount - this.wholeSaleHeader.discountAmount;
      this.receivedAmount = this.netAmount;
      this.remainingAmount = parseFloat(this.netAmount - this.wholeSaleHeader.depositAmount).toFixed(2);
    },
    save() {
      if (!this.saveLoading) {
        this.saveLoading = true;
        //convert to millisecond
        this.wholeSaleHeader.issueDateInMilliSeconds = commonService.convertToMilliseconds(
          this.issueDate
        );
        this.wholeSaleHeader.netAmount = parseFloat(this.netAmount).toFixed(2);
        this.wholeSaleHeader.receivedAmount = parseFloat(
          this.receivedAmount
        ).toFixed(2);
        this.wholeSaleHeader.currencyId = this.currencyId;
        wholeSaleService
          .save(this.wholeSaleHeader)
          .then(() => {
            this.goBack();
          })
          .catch((err) => {
            this.isLoading = false;
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
              this.messageDialogBox = true;
            }
          })
          .finally(() => {
            this.saveLoading = false;
          });
      }
    },

    printInvoice(divName) {
      var d = new Date();
      var t = d.toLocaleTimeString();
      var mydate = new Date().toString("MMMM yyyy");
      document.getElementById("date").innerHTML = mydate.substr(0, 16) + t;
      var printContents = document.getElementById(divName).innerHTML;

      // var originalContents = document.body.innerHTML;
      var myWindow = window.open("", "MsgWindow", "width=350,height=500");
      myWindow.document.write(printContents);

      // document.body.innerHTML = printContents;
      myWindow.print();

      // document.body.innerHTML = originalContents;
      myWindow.close();

      // clear previous cart item
      this.init();
    },
    printOrderNote(divName) {
      var d = new Date();
      var t = d.toLocaleTimeString();
      var mydate = new Date().toString("MMMM yyyy");
      document.getElementById("orderNoteDate").innerHTML =
        mydate.substr(0, 16) + t;
      var printContents = document.getElementById(divName).innerHTML;
      var originalContents = document.body.innerHTML;
      document.body.innerHTML = "";
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
    },
    init() {
      const id = this.$route.params.id;
      if (id == "new") {
        // new stockin
        this.issueDate = commonService.formatDate(
          new Date().toISOString().substr(0, 10),
          "YYYY-MM-DD"
        );
      } else {
        this.getWholeSaleDetail(id);
      }
      if (this.wholeSaleHeader) {
        this.wholeSaleHeader = new WholeSaleHeader();
      }
      this.getCreditLevels();
      this.getTax();
      this.getCategoriesByStatus()
        .then(this.getProductList)
        .then(() => {
          this.ignorePagingWatch = false;
        });
      let user = JSON.parse(localStorage.getItem("user"));
      this.roleName = user.roleName;
      if (this.roleName == "SALE_MANAGER") {
        this.wholeSaleHeader.shopId = user.shop.id;
        this.wholeSaleHeader.shopName = user.shop.name;
        this.wholeSaleHeader.isB2B = user.shop.isB2B;
      }
      this.wholeSaleHeader.username = user.username;

      // check park items
      var parkItemsLocalStorage = JSON.parse(localStorage.getItem("parkItems"));
      if (parkItemsLocalStorage) {
        this.parkItems = parkItemsLocalStorage;
      }

      //for deep linking
      if (this.$route.query.status) {
        this.queryParams.status = this.$route.query.status;
      }
      if (this.$route.query.categoryId) {
        this.queryParams.categoryId = this.$route.query.categoryId;
      }
      if (this.$route.query.barcode) {
        this.queryParams.barcode = this.$route.query.barcode;
      }
      if (this.$route.query.page) {
        this.pagination.page = this.$route.query.page;
      }
      if (this.$route.query.size) {
        this.pagination.size = this.$route.query.size;
      }
      if (this.$route.query.categoryId) {
        this.queryParams.categoryId = this.$route.query.categoryId;
      }
      if (this.$route.query.warehouseId) {
        this.queryParams.warehouseId = this.$route.query.warehouseId;
      } else {
        this.queryParams.warehouseId = user.shop.warehouse.id;
      }
    },

    showProductUnitDialog(product) {
      this.openProductUnitDialog = true;
      this.productUnitList = product.productUnits;
      this.productCode = product.code;
      this.productName = product.name;
      this.productColor = product.color;
    },

    removeItem(index, wholeSaleHeaderId) {
      if (wholeSaleHeaderId) {
        // add delete stock in id
        if (!this.wholeSaleHeader.deleteWholeSaleDetailIds) {
          this.wholeSaleHeader.deleteWholeSaleDetailIds = [];
        }
        this.wholeSaleHeader.deleteWholeSaleDetailIds.push(wholeSaleHeaderId);
      }
      this.$delete(this.wholeSaleHeader.wholeSaleDetails, index);
    },
    parkSale() {
      if (!this.$refs.noteDialog.validate()) {
        return;
      }
      this.showNote = false;

      var parkItemsLocalStorage = JSON.parse(localStorage.getItem("parkItems"));
      if (!parkItemsLocalStorage) {
        parkItemsLocalStorage = [];
      }
      parkItemsLocalStorage.push(this.wholeSaleHeader);
      this.parkItems = parkItemsLocalStorage;
      localStorage.setItem("parkItems", JSON.stringify(parkItemsLocalStorage));
      this.init();
    },
    retrieveSale(index) {
      var parkItemsLocalStorage = JSON.parse(localStorage.getItem("parkItems"));
      this.wholeSaleHeader = parkItemsLocalStorage[index];
      this.$delete(parkItemsLocalStorage, index);
      this.parkItems = parkItemsLocalStorage;
      localStorage.setItem("parkItems", JSON.stringify(parkItemsLocalStorage));
      this.showParkSales = false;
    },
    closeModal() {
      this.$refs.noteDialog.resetValidation();
      this.showNote = false;
    },
    showPaymentMethods() {
      if (this.$refs.form.validate()) {
        this.showPaymentMethodDialog = true;
        this.confirmBox = false;
        discountService.getDiscountByStatusAndDiscountType("ACTIVE","WHOLESALE").then((res) => {
          if (res.data) {
            let discount = res.data[0];
            if (discount) {
              this.discountAmount =
                discount.percentage * 0.01 * this.wholeSaleHeader.totalAmount;
            }
          }
        });
      }
    },
    isItemExist(productUnit, isFOC) {
      for (let item of this.wholeSaleHeader.wholeSaleDetails) {
        if (item.productUnitId === productUnit.id && item.isFOC === isFOC) {
          return true;
        }
      }
    },
    getProductUnitByBarcode(barcode) {
      productService
        .getProductUnitByBarcode(barcode, this.currencyId)
        .then(res => {
          let productUnit = res.data;
          if (productUnit) {
            if (productUnit.qty > 0) {
              if (productUnit.reorderQty == 0 || ((productUnit.qty * productUnit.factor) > productUnit.reorderQty && productUnit.reorderQty > 0)) {
                this.addToCart(productUnit);
              }
            }
          }
          this.scanBarcode = "";
        })
        .catch(err => {
          console.log(err);
        });
    },
    getCreditLevels() {
      creditLevelService
        .getCreditLevels()
        .then(res => {
          if (res.data) {
            this.creditLevelList = res.data.creditLevelList;
            let findAll = {
              id: "",
              name: "----All----"
            };
            this.creditLevelList.splice(
              0,
              0,
              JSON.parse(JSON.stringify(findAll))
            );
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    setCustomer(customer) {
      this.wholeSaleHeader.customerId = customer.id;
      this.wholeSaleHeader.customerName = customer.name;
      this.wholeSaleHeader.customerType = customer.customerType;
      this.showCustomerListDialog = !this.showCustomerListDialog;
      this.changeCustomer();
    },
    getWholeSaleDetail(id) {
      wholeSaleService.getWholeSaleDetail(id).then(res => {
        this.wholeSaleHeader = res.data;
        if (this.wholeSaleHeader) {
          if (this.wholeSaleHeader.taxAmount > 0) {
            this.isTaxOn = true;
          }
        }
        this.queryParams.currencyId = this.wholeSaleHeader.currencyId;
        this.currencyId = this.wholeSaleHeader.currencyId;
        this.currency = this.wholeSaleHeader.currencyCode;
        this.issueDate = commonService.millisecondToDate(
          this.wholeSaleHeader.issueDateInMilliSeconds,
          "YYYY-MM-DD"
        );
        this.status = this.wholeSaleHeader.status;
        //this.wholeSaleHeader.customerType = customer.customerType;
        //this.wholeSaleHeader.isB2B = user.shop.isB2B;
        // deep copy
        this.oldWholeSaleHeader = JSON.parse(JSON.stringify(res.data));
        this.getTax().then(()=>{
          this.calculateAmount();
        });
      });
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.wholeSaleHeader.id) {
        this.wholeSaleHeader = new WholeSaleHeader();
      } else {
        this.wholeSaleHeader = Object.assign({}, this.oldWholeSaleHeader);
      }
    },
    getActiveCurrency(){
    return currencyService.getCurrencyByStatus('ACTIVE')
    .then(res => {
      if(res.data){
        this.currencyList = res.data;
        let c = commonService.search("defaultCurrency",true,this.currencyList);
        if(c){
          this.currencyId = c.id;
          this.onSearch();
        }
      }
    })
    .catch((err) => {
          if (err.response.data) {
            this.responseError = err.responseError.data.message;
          }
        });
    },
    goBack() {
      this.$router.push("/whole-sales");
    },
    changeCustomer(){
      this.wholeSaleHeader.wholeSaleDetails.forEach((item)=>{
        if(this.wholeSaleHeader.isB2B && this.wholeSaleHeader.customerType == "B2B"){
          item.unitPrice = item.unitCost;
        }else{
          item.unitPrice = item.wholeSalePrice;
        }
      });
    }
  }
};
</script>

<style scoped>
.stock-name {
  width: 110px;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.cart {
  font-size: 12px;
}
.small-font {
  font-size: 12px;
}
</style>